import React from "react";
import styled from "styled-components";
import { Icon } from "@iconify/react";
import { inputStyles } from "./InputStyles";
import { Theme } from "../../themes/theme";

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 6px;
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const SearchIcon = styled(Icon)`
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: ${Theme.color.text.body};
  font-size: 18px;
  pointer-events: none;
`;

const Input = styled.input`
  ${inputStyles}
  padding-left: 42px;

  &:focus {
    outline: none;
  }

  @media (max-width: ${Theme.breakpoints.MOBILE}px) {
    font-size: ${Theme.font.fontSize.md};
  }
`;

function PrimarySearch({ ...props }) {
  return (
    <Wrapper>
      <InputWrapper>
        <SearchIcon icon="tabler:search" />
        <Input {...props} />
      </InputWrapper>
    </Wrapper>
  );
}

export default PrimarySearch;